import { render, staticRenderFns } from "./PageRecipes.vue?vue&type=template&id=7bdd3e80"
import script from "./PageRecipes.vue?vue&type=script&lang=js"
export * from "./PageRecipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports